import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { Tab } from 'ui-platform';

@Component({
  selector: 'sh-platform-tabs',
  templateUrl: './platform-tabs.component.html',
  styleUrl: './platform-tabs.component.scss',
  standalone: false
})
export class PlatformTabsComponent implements OnInit {
  @ViewChild('tab1', { static: true }) tab1!: TemplateRef<any>;
  @ViewChild('tab2', { static: true }) tab2!: TemplateRef<any>;
  @ViewChild('tab3', { static: true }) tab3!: TemplateRef<any>;

  tabs: Tab[] = [];

  ngOnInit(): void {
    this.tabs = [
      { title: 'Tab 1', contentTemplate: this.tab1 },
      { title: 'Tab 2', contentTemplate: this.tab2 },
      { title: 'Tab 3', contentTemplate: this.tab3 }
    ];
  }
}
